
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';
  import {TimelineInteractionType} from '@/models/timeline.model';

  @Component({})
  export default class TimelineItemForm extends Vue {
    @Prop({required: true}) type!: TimelineInteractionType;
  }
